import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

/**
 * Edit-mode counter of a studio: permissions added for the member vs the ones that still come
 * from roles. Plain text inside the expandable list (it must not become a summary block).
 *
 * @param {object} props
 * @param {number} props.added Permissions set directly for the member.
 * @param {number} props.fromRoles Permissions that still only come from a role.
 * @param {string} props.name Member first name.
 */
const PermissionCounter = ({ added, fromRoles, name }) => {
  const { t } = useTranslation('people-access');
  return <p className="text-xs text-content-muted">{t('studios.counter', { added, name, fromRoles })}</p>;
};

export default memo(PermissionCounter);
